import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { TableColumn } from '../../components/kiene-table/table-column';
import { MatDialog } from '@angular/material/dialog';
import { LieferantAnlegenDialogComponent } from '../../../../projects/kiene-core/src/lib/components/stammdaten/lieferant/lieferant-anlegen-dialog/lieferant-anlegen-dialog.component';
import { Futtermittellieferant } from '../../../../projects/kiene-core/src/lib/components/stammdaten/lieferant/lieferant';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableOption } from '../../components/kiene-table/table-option';

@Component({
    selector: 'kiene-futtermittellieferanten',
    templateUrl: './futtermittellieferanten.component.html',
    styleUrls: ['./futtermittellieferanten.component.scss'],
})
export class FuttermittellieferantenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        public dialog: MatDialog,
        private tableService: KieneTableService,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.headline = 'Futtermittellieferanten';
        this.tableDescriptor.uniqueIdentifier = 'Futtermittellieferanten';
        this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'futtermittellieferant/read_all.php';
        this.tableDescriptor.route = '/stammdaten/futtermittellieferanten/';
        this.tableDescriptor.nameOfIdField = 'futtermittellieferant_id';
        this.tableDescriptor.searchPlaceholder = 'Futtermittellieferanten durchsuchen';

        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.editFuttermittellieferant.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('futtermittellieferant_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Name'));
        this.tableDescriptor.columns.push(new TableColumn('strasse', 'Strasse'));
        this.tableDescriptor.columns.push(new TableColumn('plz', 'PLZ'));
        this.tableDescriptor.columns.push(new TableColumn('ort', 'Ort'));
        this.tableDescriptor.columns.push(new TableColumn('telefon', 'Festnetz'));
        this.tableDescriptor.columns.push(new TableColumn('mobil', 'Mobil'));
        this.tableDescriptor.columns.push(new TableColumn('fax', 'Fax'));
        this.tableDescriptor.columns.push(new TableColumn('email', 'E-Mail'));
        this.tableDescriptor.columns.push(new TableColumn('qs_id', 'QS ID'));
        this.tableDescriptor.columns.push(new TableColumn('editiert', 'Editiert', 'datetime'));

        this.tableDescriptor.permissionView = 9391;
        this.tableDescriptor.permissionCreate = 9392;

        this.tableDescriptor.options.push(
            new TableOption(this.editFuttermittellieferant.bind(this), 'editieren', 'edit', 9392),
        );

        this.tableDescriptor.initialSortColumn = 'futtermittellieferant_id';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.addFuttermittellieferant.bind(this);
    }

    addFuttermittellieferant() {
        this.editFuttermittellieferant(new Futtermittellieferant());
    }

    editFuttermittellieferant(fml: Futtermittellieferant) {
        this.dialog
            .open(LieferantAnlegenDialogComponent, { data: fml })
            .afterClosed()
            .subscribe({
                next: (lieferant: Futtermittellieferant) => {
                    if (lieferant) {
                        this.tableService.reload();
                    }
                },
            });
    }
}
